import { isProduction, isStaging } from '@common/lib/env';

type ApiUri = string;
type ApiUriWebsocket = string;

type WebsocketProtocol = string;

const Websocket = 'ws:';
const WebsocketWithSSL = 'wss:';

export const getApiUri = (): ApiUri => {
  const { protocol, host } = window.location;
  return `${protocol}//${host}`;
};

export const getApiUriWebsocket = (): ApiUriWebsocket => {
  const { host } = window.location;
  return `${getWebsocketProtocol()}//${host}`;
};

const getWebsocketProtocol = (): WebsocketProtocol => {
  return isProduction || isStaging ? WebsocketWithSSL : Websocket;
};
